<template>
  <div>
    <div v-if="noPageState">
      <noMessage></noMessage>
    </div>
    <div v-if="pageState" class="have_con">
      <div class="prompt">
        <div class="prompt_title">
            <span class="prompt_title_sub">车辆信息</span>
        </div>
      </div>

      <div v-if="orderState===0">
        <div v-for="(item,index) in vehicle" :key="index">
          <div class="white_empty"></div>
          <!-- 基本信息 -->
          <div class="background">
            <div class="basic">
              <p class="basic_plate">车牌号：{{item.plateNum}}</p>
              <p class="basic_type"></p>
              <p class="basic_apple">车牌颜色：{{item.plateColor | getPlateColor}}</p>
              <p class="basic_id">名称：{{item.name}}</p>
              <span class="btn" @click="SelectOrder(index)">详情</span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="orderState===1">
        <div class="white_empty"></div>
        <!-- 基本信息 -->
        <div class="background" >
          <div class="basic">
            <p class="basic_plate">车牌号：{{vehicle[orderIndex].plateNum}}</p>
            <p class="basic_type"></p>
            <p class="basic_apple">车牌颜色：{{vehicle[orderIndex].plateColor | getPlateColor}}</p>
            <p class="basic_id">名称：{{vehicle[orderIndex].name}}</p>
            <span class="btn" @click="SelectOrder">收起</span>
          </div>
        </div>
        <!-- 查询详情 -->
        <div class="credit_particular">
          <div class="message_item">
            <div class="left"><span>名称：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].name}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>

          <div class="message_item">
            <div class="left"><span>车牌号：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].plateNum}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>

          <div class="message_item">
            <div class="left"><span>车牌颜色：</span></div>
            <div class="right">{{vehicle[orderIndex].plateColor | getPlateColor}}</div>
            <!-- <span class="white_line"></span> -->
          </div>

          <div class="message_item">
            <div class="left"><span>车架号：</span></div>
            <div class="right">{{vehicle[orderIndex].vin}}</div>
            <!-- <span class="white_line"></span> -->
          </div>

          <div class="message_item">
            <div class="left"><span>发动机号：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].engineNum}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>

          <div class="message_item">
            <div class="left"><span>行驶证发证日期：</span></div>
            <div class="right">{{vehicle[orderIndex].issueDate}}</div>
            <!-- <span class="white_line"></span> -->
          </div>

          <div class="message_item">
            <div class="left"><span>注册日期：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].registerDate}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>

          <div class="message_item">
            <div class="left"><span>车辆类型：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].vehicleType}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>

          <div class="message_item">
            <div class="left"><span>核定人数：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].approvedCount}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>

          <div class="message_item">
            <div class="left"><span>总质量：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].totalMass}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>

          <div class="message_item">
            <div class="left"><span>整备质量：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].maintenaceMass}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>

          <div class="message_item">
            <div class="left"><span>核定载质量：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].permittedWeight}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>

          <div class="message_item">
            <div class="left"><span>车辆尺寸：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].outsideDimensions}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>
          <div class="message_item">
            <div class="left"><span>使用性质：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].useCharacter == 1 ? '营运' : vehicle[orderIndex].useCharacter == 2 ? '非营运' : ''}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>
          <div class="message_item">
            <div class="left"><span>行驶证住址：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].address}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>
          <div class="message_item">
            <div class="left"><span>档案编号：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].fileNum}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>
          <div class="message_item">
            <div class="left"><span>准牵引总质量：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].permittedTowWeight}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>
          <div class="message_item">
            <div class="left"><span>轴数：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].noOfAxles}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>
          <div class="message_item">
            <div class="left"><span>号牌种类：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].carType}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>
          <div class="message_item">
            <div class="left"><span>品牌：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].carBrand}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>
          <div class="message_item">
            <div class="left"><span>车型：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].carModel}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>
          <div class="message_item">
            <div class="left"><span>排量：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].displacement}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>
          <div class="message_item">
            <div class="left"><span>年检日期：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].jianCheTime}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>
          <div class="message_item">
            <div class="left"><span>车身颜色：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].color}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>
          <div class="message_item">
            <div class="left"><span>出厂日期：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].prodDate}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>
          <div class="message_item">
            <div class="left"><span>燃料种类：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].fuelType}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>
          <div class="message_item">
            <div class="left"><span>强制报废日期：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].retireDate}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>
          <div class="message_item">
            <div class="left"><span>发动机型号：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].engineModel}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>
          <div class="message_item">
            <div class="left"><span>发动机最大功率：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].enginesMaxPower}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>
          <div class="message_item">
            <div class="left"><span>轴距：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].wheelbase == 'null' ? null : vehicle[orderIndex].wheelbase}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>
          <div class="message_item">
            <div class="left"><span>前轮距：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].frontTread}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>
          <div class="message_item">
            <div class="left"><span>后轮距：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].rearTread}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>
          <div class="message_item">
            <div class="left"><span>Obu办理状态：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].obuStatus}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>
          <div class="message_item">
            <div class="left"><span>车户校验结果：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].ownerCheck}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>

          <div class="message_item">
            <div class="left"><span>机动车状态：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].status}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>

          <div class="message_item">
            <div class="left"><span>收费类型：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].type}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>

          <div class="message_item">
            <div class="left"><span>车轮数：</span></div>
            <div class="right"><span>{{vehicle[orderIndex].wheelCount}}</span></div>
            <!-- <span class="white_line"></span> -->
          </div>
        </div>
      </div>
      <div class="flow_back_style"></div>
    </div>
  </div>
</template>

<script>
import { axios } from '../../util/request'
import noMessage from '../messageHint/noMessage'
import { log } from 'util'
const USERID = "USER-ID"
export default {
  data() {
    return {
      // 判断加载页面
      pageState: false,
      noPageState: false,
      // 查看那个订单
      orderIndex: 1,
      // 要显示详情还是全部订单
      orderState:0,
      userEntrance:{
        userId:''
      },
      vehicle:[],
    }
  },
  methods:{
    SelectOrder(index){
      this.orderIndex = index;
      if(this.orderState === 0){
        this.orderState = 1
      }else{
        this.orderState = 0
      }
    },
    // 弹框内容
    showMessage(title,content){
      this.$createDialog({
          type: 'alert',
          title: title,
          content: content,
          icon: 'cubeic-alert'
      }).show()
    },
    // 收费类型
    typeSelect(type){
      switch (type) {
        case 1: return "一型客车"
        case 2: return "二型客车"
        case 3: return "三型客车"
        case 4: return "四型客车"
        case 11: return "一型货车"
        case 12: return "二型货车"
        case 13: return "三型货车"
        case 14: return "四型货车"
        case 15: return "五型货车"
        case 16: return "六型货车"
        case 21: return "一型专项作业车"
        case 22: return "二型专项作业车"
        case 23: return "三型专项作业车"
        case 24: return "四型专项作业车"
        case 25: return "五型专项作业车"
        case 26: return "六型专业作业车"
        default: return ""
      }
    }
  },
  mounted(){
    this.userEntrance.userId = sessionStorage.getItem(USERID)
    if(this.userEntrance.userId){
      axios.post('/Vehicle/QueryVehicle',this.userEntrance).then(data => {
        if(data.list){
          for(let i = 0;i < data.list.length;i++){
            data.list[i].type = this.typeSelect(data.list[i].type)
          }
          this.vehicle = data.list
          this.pageState = true
        }else{
          this.noPageState = true
        }
      });
    }else{
      // this.showMessage("请你登录后，查询个人信息")
      this.$router.push({name: 'home'});
    }
  },
  components: {
    noMessage
  },
}
</script>

<style lang="less" scoped>
@import '../../assets/styles/varibles.less';
.have_con {
  padding-top: 2px;
  background-color: #fff;
}
.prompt{
  width: calc(100%);
  height : 2.3rem;
  margin: 0rem auto;
  // background-color : #EFEFEF;
  background-color: @titleColor;
}
.prompt_title{
  width: calc(100%);
  height : 1rem;
}
.prompt_title_sub{
  width: calc(100%);
  height: 1rem;
  // color: #494949;
  color: #fff;
  font-weight: 540;
  line-height: 0.5rem;
  display: block;
  margin: 0rem 0 1rem 0;
  padding: 1rem 0 1rem 0;
  text-align: left;
  text-indent: 1rem;
  font-size: 1rem;
}
.white_empty{
  background-color: #FFFFFF;
  height: 1rem;
  width: 100%;
}
.background{
  background-color: #FFFFFF;
  
}
.basic{
  width: 92%;
  height: 6rem;
  border-radius: 0.5rem;
  margin: auto;
  color: #FEFCFD;
  background-color: #F18500;
  position: relative;
  span {
    display: inline-block;
    height: 30px;
    width: 62px;
    font-size: 15px;
    background-color: #fff;
    color: #929292;
    border-radius: 17px;
    line-height: 30px;
    position: absolute;
    top: 10px;
    right: 14px;
  }
}
.basic_plate{
  display: inline-block;
  text-align: left;
  width: 55%;
  font-size: 19px;
  padding: 18px 0px 0px 0px;
}
.basic_type{
  display: inline-block;
  text-align: right;
  width: 35%;
  font-size: 0.75rem;
  padding: 0.5rem 0rem 0rem 0rem;
}
.basic_apple{
  font-size: 0.75rem;
  text-align: left;
  padding: 0.5rem 0rem 0rem 1.1rem;
}
.basic_id{
  display: inline-block;
  width: 90%;
  font-size: 0.75rem;
  text-align: left;
  padding: 8px 0px 0px 0px;
}
.basic_img{
  display: inline-block;
  width: 20%;
  font-size: 0.75rem;
  text-align: right;
  padding: 8px 0px 0px 0px;
}
.but_ton{
  width: calc(100%);
  height: 8rem;
  background: #ffffff;
}
.look_btn {
  width: 15rem;
  height: 3rem;
  display: inline-block;
  text-align: center;
  background-color: #ffffff;
  color: #797979;
  font-size: 0.94rem ;
  font-weight: 400;
  border-radius: 1.56rem;
  border:1px solid #797979;
  margin: 2rem 0rem 0rem 0rem;
}
.next_btn {
  width: 6.5rem;
  height: 2rem;
  display: inline-block;
  text-align: center;
  background-color: #ffffff;
  color: #f18934;
  font-size: 0.94rem ;
  font-weight: 400;
  margin-top: 1.56rem;
  border-radius: 1.56rem;
  border:1px solid #f18934;
  margin: 1.56rem -7rem 0rem 0rem;
}
  
  
.flow_back_style{
    width: auto;
    height: 3.125rem;
    background-color: #fff;
}

.credit_particular {
  padding: 0.625rem 1.25rem 3rem;
  .message_item {
    width: 100%;
    border-bottom: 1px solid #ededed;
    text-align: left;
    color: #6c6c6c;
    font-size: 0.75rem;
    line-height: 100%;
    overflow: hidden;
    padding-top: 0.72rem;
    padding-bottom: 0.72rem;
    .left {
      float: left;
      margin-left: 0.625rem;
      margin-right: 1.75rem;
      width: 4.68rem;
      height: 100%;
      line-height: 100%;
    }
    .right {
      float: left;
      height: 100%;
      width: 13.5rem;
    }
  }
}
</style>